import type { PharmaVariantMetadata } from '@lib/types/pharma';
import type { CartItemVM } from 'types/view-models';

const MAX_QTY_FROM_INVENTORY = 10;

export type CartItemPharmaInfo = {
  hasConsultation: boolean;
  pharmaMax: number | undefined;
  maxQuantity: number;
  showStepper: boolean;
};

export function useCartItemPharma(
  item: Pick<CartItemVM, 'variant'>,
): CartItemPharmaInfo {
  const pharmaMeta = item.variant?.metadata as
    | PharmaVariantMetadata
    | undefined;

  const isPrescriptionOnly = pharmaMeta?.legal_classification === 'POM';
  const hasConsultation = !!pharmaMeta?.questionnaire_id;
  const pharmaMax = pharmaMeta?.max_sale_quantity;
  const maxQuantity = pharmaMax
    ? Math.min(pharmaMax, MAX_QTY_FROM_INVENTORY)
    : MAX_QTY_FROM_INVENTORY;

  return {
    hasConsultation,
    pharmaMax,
    maxQuantity,
    showStepper:
      !isPrescriptionOnly &&
      (!hasConsultation || (pharmaMax !== undefined && pharmaMax > 1)),
  };
}
